// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/assets/v1/set_image_mask_regions.proto (package protos.vision.assets.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { ProjectImage } from "./vision_asset_pb";
import { file_vision_assets_v1_vision_asset } from "./vision_asset_pb";
import type { MaskRegion } from "../../generations/v1/mask_region_pb";
import { file_vision_generations_v1_mask_region } from "../../generations/v1/mask_region_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/assets/v1/set_image_mask_regions.proto.
 */
export const file_vision_assets_v1_set_image_mask_regions: GenFile = /*@__PURE__*/
  fileDesc("Ci12aXNpb24vYXNzZXRzL3YxL3NldF9pbWFnZV9tYXNrX3JlZ2lvbnMucHJvdG8SF3Byb3Rvcy52aXNpb24uYXNzZXRzLnYxItMBChpTZXRJbWFnZU1hc2tSZWdpb25zUmVxdWVzdBJKCgZwYXJhbXMYASABKAsyOi5wcm90b3MudmlzaW9uLmFzc2V0cy52MS5TZXRJbWFnZU1hc2tSZWdpb25zUmVxdWVzdC5QYXJhbXMaaQoGUGFyYW1zEhIKCnByb2plY3RfaWQYASABKAkSEAoIaW1hZ2VfaWQYAiABKAkSOQoHcmVnaW9ucxgDIAMoCzIoLnByb3Rvcy52aXNpb24uZ2VuZXJhdGlvbnMudjEuTWFza1JlZ2lvbiKqAQobU2V0SW1hZ2VNYXNrUmVnaW9uc1Jlc3BvbnNlEksKBnJlc3VsdBgBIAEoCzI7LnByb3Rvcy52aXNpb24uYXNzZXRzLnYxLlNldEltYWdlTWFza1JlZ2lvbnNSZXNwb25zZS5SZXN1bHQaPgoGUmVzdWx0EjQKBWltYWdlGAEgASgLMiUucHJvdG9zLnZpc2lvbi5hc3NldHMudjEuUHJvamVjdEltYWdlYgZwcm90bzM", [file_vision_assets_v1_vision_asset, file_vision_generations_v1_mask_region]);

/**
 * @generated from message protos.vision.assets.v1.SetImageMaskRegionsRequest
 */
export type SetImageMaskRegionsRequest = Message<"protos.vision.assets.v1.SetImageMaskRegionsRequest"> & {
  /**
   * @generated from field: protos.vision.assets.v1.SetImageMaskRegionsRequest.Params params = 1;
   */
  params?: SetImageMaskRegionsRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.assets.v1.SetImageMaskRegionsRequest.
 * Use `create(SetImageMaskRegionsRequestSchema)` to create a new message.
 */
export const SetImageMaskRegionsRequestSchema: GenMessage<SetImageMaskRegionsRequest> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_set_image_mask_regions, 0);

/**
 * @generated from message protos.vision.assets.v1.SetImageMaskRegionsRequest.Params
 */
export type SetImageMaskRegionsRequest_Params = Message<"protos.vision.assets.v1.SetImageMaskRegionsRequest.Params"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string image_id = 2;
   */
  imageId: string;

  /**
   * @generated from field: repeated protos.vision.generations.v1.MaskRegion regions = 3;
   */
  regions: MaskRegion[];
};

/**
 * Describes the message protos.vision.assets.v1.SetImageMaskRegionsRequest.Params.
 * Use `create(SetImageMaskRegionsRequest_ParamsSchema)` to create a new message.
 */
export const SetImageMaskRegionsRequest_ParamsSchema: GenMessage<SetImageMaskRegionsRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_set_image_mask_regions, 0, 0);

/**
 * @generated from message protos.vision.assets.v1.SetImageMaskRegionsResponse
 */
export type SetImageMaskRegionsResponse = Message<"protos.vision.assets.v1.SetImageMaskRegionsResponse"> & {
  /**
   * @generated from field: protos.vision.assets.v1.SetImageMaskRegionsResponse.Result result = 1;
   */
  result?: SetImageMaskRegionsResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.assets.v1.SetImageMaskRegionsResponse.
 * Use `create(SetImageMaskRegionsResponseSchema)` to create a new message.
 */
export const SetImageMaskRegionsResponseSchema: GenMessage<SetImageMaskRegionsResponse> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_set_image_mask_regions, 1);

/**
 * @generated from message protos.vision.assets.v1.SetImageMaskRegionsResponse.Result
 */
export type SetImageMaskRegionsResponse_Result = Message<"protos.vision.assets.v1.SetImageMaskRegionsResponse.Result"> & {
  /**
   * @generated from field: protos.vision.assets.v1.ProjectImage image = 1;
   */
  image?: ProjectImage | undefined;
};

/**
 * Describes the message protos.vision.assets.v1.SetImageMaskRegionsResponse.Result.
 * Use `create(SetImageMaskRegionsResponse_ResultSchema)` to create a new message.
 */
export const SetImageMaskRegionsResponse_ResultSchema: GenMessage<SetImageMaskRegionsResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_set_image_mask_regions, 1, 0);

